module.exports = __webpack_public_path__ + "images/index/img03.79ad0bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/artfriends/img03.jpg
// module id = iLGu
// module chunks = 21